<template>
    <div id="app">
        <app-header ref="header" />
        <app-content ref="content">
            <slot />
        </app-content>
        <app-footer ref="footer" />
    </div>
</template>

<script>

import AppHeader from 'components/app/AppHeader.vue';
import AppFooter from 'components/app/AppFooter.vue';
import AppContent from 'components/app/AppContent.vue';

export default {
  name: 'MainLayout',
  components: {
    AppContent, AppHeader, AppFooter
  }
}
</script>
